import { palette } from '@shared/tokens/palette.stylex';
import { FC } from 'react';

interface InfoFilledIconProps {
  color?: string;
  size?: string;
}

export const InfoFilledIcon: FC<InfoFilledIconProps> = ({ color = palette['blue-500'], size = '20' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.875 10C1.875 5.51269 5.51269 1.875 10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10ZM9.1302 8.79871C10.0854 8.32111 11.1609 9.18386 10.9019 10.2199L10.3111 12.5833L10.3456 12.566C10.6544 12.4116 11.0298 12.5368 11.1842 12.8455C11.3385 13.1542 11.2134 13.5297 10.9046 13.684L10.8701 13.7013C9.91488 14.1789 8.83936 13.3162 9.09838 12.2801L9.68922 9.91674L9.65464 9.93403C9.34591 10.0884 8.97049 9.96326 8.81612 9.65452C8.66175 9.34578 8.78689 8.97036 9.09563 8.81599L9.1302 8.79871ZM10 7.5C10.3452 7.5 10.625 7.22018 10.625 6.875C10.625 6.52982 10.3452 6.25 10 6.25C9.65482 6.25 9.375 6.52982 9.375 6.875C9.375 7.22018 9.65482 7.5 10 7.5Z"
        fill={color}
      />
    </svg>
  );
};
